import { Location } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService, Picture, User } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import { LoaderService } from '../../services/loader.service';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { ToastService } from '../../services/toast.service';
import { DeletePicturePopupComponent } from '../popup/types/deletePicture/popup-delete-picture.component';
import { PopupService } from '../../services/popup.service';

@Component({
    selector: 'ez-album',
    template: require('./album.component.html'),
    styles: [require('./album.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class AlbumComponent implements OnInit, OnDestroy {
    private user: User;
    private pictureIndex: number = 0;
    public static readonly MAX_PICTURES = 6;
    @ViewChild('pictures') private container: ElementRef;
    @ViewChild(SwiperDirective) private swiper: SwiperDirective;
    public mediaUri: string;

    public confirmSentence: string = '';
    public subs: Subscription[] = [];

    public readonly swiperConfig: SwiperConfigInterface = {
        direction: 'horizontal',
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    };

    private selectedPicture: Picture = null;

    constructor(
        private apiService: ApiService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private loader: LoaderService,
        private translationService: TranslateService,
        private renderer: Renderer2,
        private toastService: ToastService,
        private popupService: PopupService
    ) {
        this.mediaUri = '//' + environment.statichost + '/media/';
        this.renderer.addClass(document.querySelector('#logged-content'), 'fullscreen-mode');
    }

    public ngOnInit() {
        this.loader.show();
        this.apiService.user().subscribe(result => {
            this.loader.hide();
            let user = result;
            this.user = user;

            this.route.params.subscribe((params) => {
                if (params.id !== undefined) {
                    for (let i in user.pictures) {
                        if (user.pictures[i].id === parseInt(params.id)) {
                            this.selectedPicture = user.pictures[i];
                            this.pictureIndex = parseInt(i);
                        }
                    }
                } else if (user.pictures.length > 0) {
                    this.selectedPicture = user.pictures[0];
                }
            });

            this.swiper.update();
        }, error => {
            this.loader.hide(5000, 'alert', error);
        });

        this.translationService.get('pictures.confirm-delete').subscribe(sentence => {
            this.confirmSentence = sentence;
        });
    }

    public ngOnDestroy() {
        this.subs.forEach(a => a.unsubscribe());
        this.renderer.removeClass(document.querySelector('#logged-content'), 'fullscreen-mode');
    }

    private savePictureAccess(picture: Picture) {
        picture.isPrivate = picture.access === 'private' || picture.access === 'censored';
        this.apiService.pictureSetAccess(picture).subscribe(r => {
            console.log(r);
        });
    }

    public toggleDefault(picture: Picture) {
        // can't toggle default picture
        if (picture.access === 'default') {
            return false;
        }

        if (picture.access === 'censored') {
            return;
        }

        picture.access = picture.access === 'default' ? 'all' : 'default';
        // if the picture now have default access, set all others pictures to 'all' access (can't have many pictures with default access)
        if (picture.access === 'default') {
            this.user.pictures.forEach((apic) => {
                if (apic !== picture && apic.access === 'default') {
                    apic.access = 'all';
                }
            });
        }

        this.savePictureAccess(picture);
    }

    public togglePrivate(picture: Picture) {
        if (picture.access === 'censored') {
            return;
        }
        picture.access = picture.access === 'private' ? 'all' : 'private';
        this.savePictureAccess(picture);
    }

    public trash(picture: Picture) {
        this.popupService.showPopup(DeletePicturePopupComponent, {
            sentence: this.confirmSentence,
            lastPublicPicture: this.user.getPublicPictures().length === 1
        }).subscribe(data => {
            if (data.result === true) {
                this.user.pictures.splice(this.user.pictures.indexOf(picture), 1);
                // go back to previous if exists
                if (this.user.pictures.length > 0 && this.pictureIndex > 0) {
                    this.pictureIndex -= 1;
                }

                if (this.user.pictures[this.pictureIndex] !== undefined) {
                    this.selectedPicture = this.user.pictures[this.pictureIndex];
                } else {
                    this.selectedPicture = null;
                }

                this.swiper.update();
                this.apiService.pictureDelete(picture).subscribe(() => {});

                // Deleted picture has the default access, set other public picture to default
                let publicPicture = this.user.getPublicPictures();
                if (picture.access === 'default' && publicPicture.length > 0) {
                    let newDefaultPicture = publicPicture[0];
                    newDefaultPicture.access = 'default';
                    this.apiService.pictureSetAccess(newDefaultPicture).subscribe((res) => {});
                }
            }

            this.popupService.close();
        });
    }

    public indexChange(index) {
        if (index <= this.user.pictures.length - 1) {
            this.selectedPicture = this.user.pictures[index];
        } else {
            this.selectedPicture = null;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/album/album.component.ts